import { modalComponentModule } from '../../../../shared/app/components/modal/modal';
import { appAlertComponentModule } from '../../../../shared/app/components/app-alert/app-alert';
import editProfileDialogTemplate from './edit-profile-dialog.tpl.html';
import { candidateModelModule } from '../../../../shared/app/models/candidate';
import { accountServiceModule } from '../../../../shared/app/services/account-service/account-service';

export const editProfileDialogComponentModule = angular
  .module('Q.components.edit-profile-dialog', [
    accountServiceModule,
    candidateModelModule,
    modalComponentModule,
    appAlertComponentModule,
  ])

  .factory('editProfileDialog', function editProfileDialog($modal) {
    return {
      /**
       * @param {TeamCandidate} teamCandidate - team candidate to edit
       */
      open: function () {
        return $modal.openOnce('editProfileDialog', {
          template: editProfileDialogTemplate,
          controller: 'EditProfileDialogCtrl as $ctrl',
          // resolve: {},
        }).result;
      },
    };
  })

  .controller(
    'EditProfileDialogCtrl',
    function EditProfileDialogCtrl(
      $modalInstance,
      accountService,
      Candidate,
      appAlert,
    ) {
      const ctrl = this;
      const user = accountService.get().user;

      ctrl.data = {
        firstName: user.firstName,
        lastName: user.lastName,
      };
      ctrl.candidate = user;

      $modalInstance.preventDismissWhen(() => {
        return Object.keys(ctrl.data).some((k) => ctrl.data[k] !== user[k]);
      });

      ctrl.save = function () {
        ctrl.disabled = true;
        Candidate.update(user, ctrl.data)
          .then(() => {
            appAlert.success('Saved');
            $modalInstance.close(user);
          })
          .catch(appAlert.modelError)
          .finally(() => (ctrl.disabled = false));
      };

      ctrl.cancel = () => {
        $modalInstance.dismiss('cancel');
      };
    },
  );
